__turbopack_context__.v({
  "embla": "reviews-carousel-module-scss-module__kRnXCG__embla",
  "embla__buttons": "reviews-carousel-module-scss-module__kRnXCG__embla__buttons",
  "embla__container": "reviews-carousel-module-scss-module__kRnXCG__embla__container",
  "embla__slide": "reviews-carousel-module-scss-module__kRnXCG__embla__slide",
  "embla__viewport": "reviews-carousel-module-scss-module__kRnXCG__embla__viewport",
});
